// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39Fq5","rightAdornment":"Header_rightAdornment__FlUDW"};